/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { ProjectApi } from "client";
import { useApiWithTimeout } from "hooks/ApiWrapperWithTimeout";
import { useCallApi } from "hooks/CallApiHook";
import { Const } from "const";

export const useGetProject = () => {
  const [projectApi, cancelProjectApi] = useApiWithTimeout(
    ProjectApi,
    Const.operationTimeout.getProjectList
  );

  return useCallApi(
    async () => {
      const res = await projectApi.getProjectList();
      if ((res.projects?.length ?? 0) > 0) {
        return res;
      } else {
        throw new Error("jobsite list is empty");
      }
    },
    cancelProjectApi,
    [projectApi]
  );
};
